export default __webpack_public_path__ + "static/040-9042bbea0b6084f97c3a97f37852f3b3.jpg";